import React from 'react';
import { Layout, ConfigProvider } from 'antd';
import { getTheme, useTheme } from '../../resources/theme';
import { useSideBarCollapse } from './hooks/useSideBarCollapse';
import HeaderLayout from './layout/header-layout';
import SiderLayout from './layout/sider-layout';
import ContentLayout from './layout/content-layout';
import FooterLayout from './layout/footer-layout';
import { BreadcrumbRoutes } from '../breadcrumb';

const LayoutPage = () => {
  const { sidebarMode, switchTheme, globalTheme } = useTheme();
  const { collapsed, toggleCollapse } = useSideBarCollapse();

  return (
    <ConfigProvider theme={globalTheme}>
      <SiderLayout collapsed={collapsed} getTheme={getTheme} sidebarMode={sidebarMode} />
      <Layout
        className="site-layout"
        style={{
          minHeight: '100vh',
          marginLeft: collapsed ? 80 : 280,
        }}
      >
        <HeaderLayout
          getTheme={getTheme}
          collapsed={collapsed}
          sidebarMode={sidebarMode}
          toggleCollapse={toggleCollapse}
          switchTheme={switchTheme}
        />
        <BreadcrumbRoutes />
        <ContentLayout getTheme={getTheme} sidebarMode={sidebarMode} />
        <FooterLayout />
      </Layout>
    </ConfigProvider>
  );
};

export default LayoutPage;
